import { useAuth } from "@/context/AuthContext";

/** True when the signed-in user is a company sub-account with sub_role="viewer" (read-only). */
export function useIsViewer() {
  const { user } = useAuth();
  return user && user.role === "company" && user.sub_role === "viewer";
}

/** True when the signed-in user is a company sub-account with any sub_role (manager or viewer). */
export function useIsSubAccount() {
  const { user } = useAuth();
  return user && user.role === "company" && !!user.sub_role;
}
